import React, { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import type { SxProps, Theme } from '@mui/material/styles';
import type { BoxProps } from '@mui/material/Box';

import SectionTitle from './SectionTitle';

interface ContentContainerProps extends Omit<BoxProps, 'title' | 'sx'> {
  title?: string | ReactNode;
  sx?: SxProps<Theme>;
  titleVariant?: 'sm' | 'md' | 'lg';
  titleIsHeader?: boolean;
  children?: ReactNode;
  titleSx?: SxProps<Theme>;
  paperSx?: SxProps<Theme>;
}

export default function ContentContainer({
  title = '',
  sx = {},
  titleVariant = 'lg',
  titleIsHeader = false,
  children,
  titleSx = {},
  paperSx = {},
  ...paperProps
}: ContentContainerProps) {
  const getRenderedTitle = () => {
    if (React.isValidElement(title)) {
      return title;
    }
    if (typeof title === 'string') {
      return (
        <SectionTitle sx={titleSx} size={titleVariant}>
          {title}
        </SectionTitle>
      );
    }

    return null;
  };

  return (
    <Box {...paperProps} sx={paperSx} component="section">
      {titleIsHeader ? (
        <>
          {getRenderedTitle()}
          <Box padding={3} marginBottom={3} flexGrow={1} sx={sx}>
            {children}
          </Box>
        </>
      ) : (
        <Stack spacing={3} padding={3} pt={title ? 2 : 0} marginBottom={3} flexGrow={1} sx={sx}>
          {getRenderedTitle()}
          {children}
        </Stack>
      )}
    </Box>
  );
}
